import countriesJson from "./countries.json";

export const COUNTRIES = countriesJson.map((country) => ({
  label: country.name,
  value: country.name,
}));


export function removeSpaces(str) {
    // return str.replace(/\s+/g, '');
    return str.replace(/[^a-zA-Z0-9]/g, '');
  }